import { call, delay, put, takeLatest } from "redux-saga/effects";

import { IBaseRespone } from "../../../../model/respone/IBaseRespone";
import { rootActions } from "../../../actions/rootActions";
import {
  eDeThiInActionIds,
  IDeThiInActionTypes,
} from "../../../action-types/de-thi/de-thi-in/IDeThiInActions";
import { deThiInApi } from "../../../../api/de-thi/de-thi-in/deThiInApi";
import { ISMT_DeThiIn } from "../../../../model/respone/de-thi/ISMT_DeThiIn";
import { IDeThiInProgressRequest } from "../../../../model/request/de-thi/de-thi-in/IDeThiInProgressRequest";
import { ISMT_DeThiIn_Request } from "../../../../model/request/de-thi/de-thi-in/ISMT_DeThiIn_Request";
import { ISMT_DeThiIn_Vm } from "../../../../model/respone/de-thi/de-thi-in/ISMT_DeThiIn_Vm";

export function* deThiInSaga(): any {
  yield takeLatest(eDeThiInActionIds.LOAD_START, loadWorker);
  yield takeLatest(eDeThiInActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eDeThiInActionIds.SAVE_START, saveWorker);
  yield takeLatest(
    eDeThiInActionIds.DELETE_MULTIPLE_START,
    deleteMultipleWorker
  );
  yield takeLatest(eDeThiInActionIds.PROGRESS_START, progressWorker);
  yield takeLatest(eDeThiInActionIds.CHANGE_SU_DUNG_START, changeSuDungWorker);
}

function* loadWorker(action: IDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiInApi.SelectByRequest,
    action.payload as ISMT_DeThiIn_Request
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.deThiIn.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IDeThiInActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload.data as FormData;
  if (action.payload.id > 0) {
    res = yield call(deThiInApi.Update, payload);
  } else {
    res = yield call(deThiInApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      debugger;
      yield put(rootActions.deThi.deThiIn.deThiIn.SAVE_SUCCESS(res.data));
      if (action.payload.is_continue) {
        yield delay(500);
        yield put(
          rootActions.deThi.deThiIn.deThiIn.SHOW_EDIT_MODAL({
            id_chude_dethiin: action.payload.id_chude_dethiin,
          } as ISMT_DeThiIn_Vm)
        );
      }
    }
  }
}

function* deleteWorker(action: IDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiInApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.deThiIn.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* changeSuDungWorker(action: IDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiInApi.ChangeUse,
    action.payload as number
  );
  if (res.is_success) {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.CHANGE_SU_DUNG_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.CHANGE_SU_DUNG_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* deleteMultipleWorker(action: IDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiInApi.DeleteMultiple,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.DELETE_MULTIPLE_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.DELETE_MULTIPLE_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* progressWorker(action: IDeThiInActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiInApi.Progress,
    action.payload as IDeThiInProgressRequest
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThiIn.deThiIn.PROGRESS_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.deThi.deThiIn.deThiIn.PROGRESS_ERRR(res.message ?? "Thất bại")
    );
  }
}
